import { DataFormat } from "utils/format/DataFormat";

export abstract class BaseFilterListRequestModel {
  name?: string;
  code?: string;
  page?: number;
  order?: string;
  status?: number;
  type?: number;
  service?: string;
  fromDate?: string;
  toDate?: string;
  group?: string;
  limit?: number;
  serviceCode?: string;
  providerCode?: string;
  partnerCode?: string;
  pagination?: number | boolean;

  constructor(data?: Partial<BaseFilterListRequestModel>) {
    this.name = data?.name;
    this.code = data?.code;
    this.page = data?.page;
    this.limit = data?.limit;
    this.order = data?.order;
    this.status = data?.status;
    this.type = data?.type;
    this.service = data?.service;
    this.fromDate = data?.fromDate;
    this.toDate = data?.toDate;
    this.group = data?.group;
    this.serviceCode = data?.serviceCode;
    this.providerCode = data?.providerCode;
    this.partnerCode = data?.partnerCode;
    this.pagination = data?.pagination;
  }

  public removeUnknowValue?<T extends BaseFilterListRequestModel>(data: T) {
    return DataFormat.removeUndefined(
      data as unknown as Record<string, unknown>,
    );
  }
}
